import type { XYChartDotSeriesProps } from '../types/xy-chart.js';

/**
 * Dot series slot
 * @internal
 */
export const DotSeries = (props: XYChartDotSeriesProps) => null;

DotSeries['displayName'] = 'XYChart.DotSeries';
